import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { createRippleEffectRelative } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { SubHeadingDescriptionStyle } from '../../CategoryL2Page/CategoryGeneralItemListing/HorizontalVideoSection/styled';
import ImageCoverComponent from '../../CategoryL2Page/Common/ImageCoverComponent';
import {
  calculatePaddingTop,
  fireClickedCategoryCardEvent,
} from '../../CategoryL2Page/utils';
import { getSearchParams } from '../../Parenting/common';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import {
  CategoryNavigatorSection,
  NavigatorTile,
  RelatedCategoryCover,
} from './styled';
import { BestSellerHeading } from '../L1CategoryPage/ExploreSubCatProducts/styled';

const RelatedCategoryNavigator = (props) => {
  const { data, categoryId } = props;
  const relatedCategoryData = data;
  const [cardEffect, setCardEffect] = useState({ index: -1 });
  const backgroundImage = relatedCategoryData?.sectionBgImage;
  const { subHeading } = relatedCategoryData;
  const { heading } = relatedCategoryData?.headerCard;
  const sectionBgMRatio = calculatePaddingTop(
    relatedCategoryData?.sectionBgMobileImageRatio,
  );
  const sectionBgDRatio = calculatePaddingTop(
    relatedCategoryData?.sectionBgDesktopImageRatio,
  );
  const sectionBgImage = relatedCategoryData?.sectionBgImageDesktop;

  const router = useRouter();
  const tileClickHandler = (event, index, item) => {
    createRippleEffectRelative(
      event,
      document.getElementById('navTile' + index),
    );
    fireClickedCategoryCardEvent({
      id: categoryId,
      card_name: item?.title,
      card_id: item?.id,
      section_name: relatedCategoryData?.itemName,
      section_id: relatedCategoryData?._id,
      deeplink_value: item?.webUrl,
    });
  };
  const callbackFunction = (index, deeplinkValue) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    setTimeout(() => {
      setCardEffect({ index: -1 });
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  return (
    <CategoryNavigatorSection>
      {heading && <BestSellerHeading>{heading}</BestSellerHeading>}
      {subHeading && (
        <SubHeadingDescriptionStyle>{subHeading}</SubHeadingDescriptionStyle>
      )}

      {backgroundImage ? (
        <ImageCoverComponent
          imageRatioMobile={sectionBgMRatio}
          imageRatioDesktop={sectionBgDRatio}
          mobileImage={backgroundImage}
          desktopImage={sectionBgImage}
        />
      ) : null}
      <RelatedCategoryCover>
        {' '}
        {relatedCategoryData?.items?.map((item, index) => {
          return (
            <AnchorCoverTag
              url={item?.webUrl}
              key={`category${index}`}
              cardEffect={cardEffect.index === index ? 'lowOpacity' : ''}
              callbackFunction={callbackFunction}
              index={index}
            >
              <NavigatorTile
                id={'navTile' + index}
                onClick={(e) => tileClickHandler(e, index, item)}
              >
                <p>{item?.title}</p>
                <span></span>
                <img src={images.arrowDownForward} alt="" loading="lazy" />
              </NavigatorTile>
            </AnchorCoverTag>
          );
        })}
      </RelatedCategoryCover>
    </CategoryNavigatorSection>
  );
};

export default RelatedCategoryNavigator;
